<template>
  <v-container>
    <div class="quota-allocation-pg">
      <div class="breadcrumbs-wrap">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      </div>
      <h1 class="title-pg"> {{ oopt.transName }} > {{ $t('Лимиты') }}</h1>
      <div class="my-organization">
        <div class="quotas-pg quota-limits bgw-pdg-20">
          <div class="flex-two-col">
            <div class="flex-two-col__left">
              <Menu :ooptId="oopt.id"/>
            </div>
          </div>
          <div class="flex-two-col">
            <div class="flex-two-col__left">
              <ul class="list-column">
                <li v-for="(year, i) in refYear" :class="{ active: year.id === yearId }" :key="i">
                  <a href="#" @click="changeYear(year.id)">{{ year.year }}</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="table-overflow">
            <table class="table-full">
              <thead>
              <tr>
                <td class="td-num">№</td>
                <td>{{ $t('Вид животного') }}</td>
                <td>{{ $t('Норматив пользования') }} %</td>
                <td>{{ $t('Кол-во голов') }}</td>
                <td>{{ $t('Дата расчета') }}</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(limit, i) in limits" :key="i">
                <td class="td-num">{{ i + 1 }}</td>
                <td>{{ limit.faunaName }}</td>
                <td>{{ limit.usageStandard }}</td>
                <td>{{ limit.headQuantity }}</td>
                <td>{{ new Date(limit.updatedDate) | dateFormat('DD.MM.YYYY') }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import Limit from '@/model/limit'
import Menu from '@/components/quota/Menu'
import { mapMutations } from 'vuex'

export default {
  components: {
    Menu
  },
  data: () => ({
    breadcrumbs: [],
    refYear: [],
    oopt: {},
    limits: [],
    yearId: null
  }),
  mounted () {
    this.fetchData()
  },
  watch: {
    yearId () {
      this.getLimitListByOoptYear()
    }
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)
      Limit.getRefYear(this.$route.params.id)
        .then((res) => {
          this.refYear = res.data.refYear
          this.oopt = res.data.oopt
          const currentYear = new Date().getFullYear()
          this.refYear.forEach((e) => {
            if (+e.year === currentYear) this.yearId = e.id
          })
          this.setLoading(false)
        })
        .catch((err) => {
          console.log(err)
          this.setLoading(false)
        })
      this.generateBreadcrumbs()
    },
    getLimitListByOoptYear () {
      this.setLoading(true)
      Limit.limitListByOoptYear(this.$route.params.id, this.yearId)
        .then((res) => {
          this.limits = res.data
          this.setLoading(false)
        })
        .catch((err) => {
          this.setLoading(false)
          console.log(err)
        })
    },
    changeYear (id) {
      this.yearId = id
    },
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Рабочий кабинет'),
          disabled: false,
          href: '/my-organization'
        },
        {
          text: this.$i18n.t('Лимиты'),
          disabled: true
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
